import { Pipe, PipeTransform } from '@angular/core';
import { TimeAgoService } from '@huge-monorepo/hip/services';

@Pipe({
  name: 'timeAgo',
  pure: false,
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private timeAgo: TimeAgoService) {}

  transform(value): any {
    return this.timeAgo.transform(value);
  }
}
